import React, { useEffect } from "react";
import $ from "jquery";
import errorImage from "../../img/app/404-error.svg";

function NotFound() {
	useEffect(() => {
		$("body").addClass("l-no-header l-no-footer");

		return () => {
			$("body").removeClass("l-no-header l-no-footer");
		};
	}, []);

	const handleGoHome = () => {
		window.location.href = "/";
	};

	return (
		<div className="global-body pt-0">
			<div className="l-content-width l-main-content-padding not-found-container">
				<div className="not-found-content">
					<div className="image-container">
						<img src={errorImage} alt="image" width={150} />
					</div>
					<h1 className="c-page-title not-found-title ">Page Not Found</h1>
					<p className="not-found-message">
						We can't seem to find the page you're looking for.
					</p>
					<p className="not-found-message2">Please navigate to another page.</p>
					<button className="c-btn bg-success c-btn--large" onClick={handleGoHome}>
						Go Back Home
					</button>
				</div>
			</div>
		</div>
	);
}

export default NotFound;
